import { Controller } from "@hotwired/stimulus"

// One code or a combination. Searchers arrive with "BDW", "MO", "EL", "DM" —
// the string their software or a forum told them to put in column (f) — and a
// single-letter select answers none of those. A combination renders one panel
// per letter, in the order given, under a line saying column (g) is the net.
export default class extends Controller {
  static targets = ["input", "select", "detail", "panel", "combo", "unknown"]

  connect() {
    const params = new URLSearchParams(window.location.search)
    const requested = this.letters(params.get("code") || "")
    if (requested.length > 0) {
      this.inputTarget.value = requested.join("")
      this.render(requested)
    } else {
      this.showSelected()
    }
  }

  // The select: one code, and the box mirrors it.
  showSelected() {
    const code = this.selectTarget.value
    this.inputTarget.value = code
    this.render([code])
  }

  // The box: whatever was typed, letters only.
  lookup() {
    const requested = this.letters(this.inputTarget.value)
    if (requested.length === 1 && this.panelFor(requested[0])) this.selectTarget.value = requested[0]
    this.render(requested)
  }

  render(codes) {
    this.detailTarget.innerHTML = ""
    const known = codes.filter((c) => this.panelFor(c))
    const unknown = codes.filter((c) => !this.panelFor(c))

    if (known.length > 1) {
      const combo = this.comboTarget.content.cloneNode(true)
      combo.querySelector("[data-combo-code]").textContent = known.join("")
      combo.querySelector("[data-combo-count]").textContent = this.count(known.length)
      this.detailTarget.appendChild(combo)
    }
    known.forEach((code) => this.detailTarget.appendChild(this.panelFor(code).content.cloneNode(true)))
    if (unknown.length > 0) {
      const note = this.unknownTarget.content.cloneNode(true)
      note.querySelector("[data-unknown-codes]").textContent = unknown.join(", ")
      this.detailTarget.appendChild(note)
    }
  }

  letters(text) {
    return [...new Set(text.toUpperCase().replace(/[^A-Z]/g, "").split(""))]
  }

  count(n) {
    return ["", "", "two", "three", "four", "five"][n] || String(n)
  }

  panelFor(code) {
    return this.panelTargets.find((p) => p.dataset.code === code)
  }
}
